import { render, staticRenderFns } from "./ChartDonut.vue?vue&type=template&id=a743aeca&scoped=true"
import script from "./ChartDonut.vue?vue&type=script&lang=js"
export * from "./ChartDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a743aeca",
  null
  
)

export default component.exports